import React, {ChangeEvent, useContext} from "react";

import "./AchAccountTypeSelect.scss";
import {CONSTANTS} from "../../../../common/constants";
import {Select} from "../../../ui-components/Select/Select";
import {CompanyContext} from "../../../../context/CompanyContext";

interface AchAccountTypeSelectProps {
    achAccountType: string;
    onSetAchAccountType: (accountType: string) => void;
}

export const AchAccountTypeSelect: React.FunctionComponent<AchAccountTypeSelectProps> = (props) => {
    const company = useContext(CompanyContext);
    let accountTypes = [CONSTANTS.ACH_ACCOUNT_TYPE.PERSONAL_CHECKING_ACCOUNT, CONSTANTS.ACH_ACCOUNT_TYPE.PERSONAL_SAVING_ACCOUNT, CONSTANTS.ACH_ACCOUNT_TYPE.BUSINESS_CHECKING_ACCOUNT, CONSTANTS.ACH_ACCOUNT_TYPE.BUSINESS_SAVING_ACCOUNT];
    if(company.is_cardconnect_enabled) {
        accountTypes = [CONSTANTS.ACH_ACCOUNT_TYPE.CARDCONNECT_CHECKING_ACCOUNT, CONSTANTS.ACH_ACCOUNT_TYPE.CARDCONNECT_SAVING_ACCOUNT];
        props.onSetAchAccountType(CONSTANTS.ACH_ACCOUNT_TYPE.CARDCONNECT_CHECKING_ACCOUNT);
    }
    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchAccountType(value);
    }

    return <div className="ach-account-type-container">
        <Select onChange={onChange}>
            {accountTypes.map((accountType: string) => {
                return <option key={accountType}
                               value={accountType}>{CONSTANTS.ACH_ACCOUNT_TYPE_NAMES[accountType]}</option>
            })}
        </Select>
    </div>
}
